module.exports = __webpack_public_path__ + "06_long_yellow.982574b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/06_long_yellow.png
// module id = /ez+
// module chunks = 0